import videojs from "video.js";
const Component = videojs.getComponent('Component');
import videojsqualityselector from 'videojs-hls-quality-selector';

export class quality extends Component {
    createEl() {
        return videojs.dom.createEl('div', {
            className: 'vjs-quality-bar'
        });
    }
}

export const initQuality = (player) => {

	const section = player.el_.closest('section');
    const qualityMenu = section ? section.querySelector('ul.quality-menu') : document.querySelector('ul.quality-menu');
    
	if ( !qualityMenu ) {
		return;
	}
	
	player.getChild('menu').getChild('quality').el_.innerHTML = `
        <div class="vjs-quality-value">${qualityMenu.querySelector('.vjs-selected').innerText}</div>
        <button class="vjs-quality-rate vjs-menu-button vjs-menu-button-popup vjs-button" type="button" aria-disabled="false" title="Quality Rate" aria-haspopup="true" aria-expanded="false"></button>
        ${qualityMenu.outerHTML}
	`;
    
	qualityMenu.remove();
    
    const newQualityMenu = section ? section.querySelector('.vjs-quality-bar > ul') : document.querySelector('.vjs-quality-bar > ul');
    const qualityMenuButton = section ? section.querySelector('.vjs-quality-bar > div.vjs-quality-value') : document.querySelector('.vjs-quality-bar > div.vjs-quality-value');
    const qualityButtons = section ? section.querySelectorAll('.vjs-quality-bar > ul > li') : document.querySelectorAll('.vjs-quality-bar > ul > li');
	const connection = window.navigator.connection;

	const changeQuality = (quality) => {
		player.hlsQualitySelector = videojsqualityselector;
		qualityButtons.forEach(item => {
			item.classList.remove('vjs-selected');
			if (item.innerText == quality) {
				player.src({
					src: item.getAttribute('data-src'),
					type: 'video/mp4',
					withCredentials: false,
				});
				qualityMenuButton.innerText = item.innerText;
				item.classList.add('vjs-selected');
			}
		});
	}
	
	if ( connection && connection.effectiveType === '3g' ) {
		changeQuality('480p');
	}

	if ( connection && connection.effectiveType === '2g' ) {
		changeQuality('360p');
	}
	
    qualityMenuButton.addEventListener('click', () => {
        newQualityMenu.classList.toggle('active');
		player.getChild('menu').el_.classList.add('submenu-active');
	})
   
	newQualityMenu.addEventListener('click', () => {
		newQualityMenu.classList.remove('active');
		player.getChild('menu').el_.classList.remove('submenu-active');
	})

	player.on("userinactive", function() {
		newQualityMenu.classList.remove('active');
	});

	for (let qualityButton of qualityButtons ) {
		qualityButton.addEventListener('click', () => {
			const currentTime = player.currentTime();
			changeQuality(qualityButton.innerText);
			player.currentTime(currentTime);
		})
	}
}